import { createAsyncThunk } from '@reduxjs/toolkit';
import { _userUrls } from '@custom/Utils/constants/apiUrls';

const deactivateUserApi = createAsyncThunk('deactivateUserApi', async (data: any) => {
    const pageLimit = 30;
    const pageNumber = 1;
    const offset = pageLimit * (pageNumber - 1);
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const search = data?.search || '';

    try {
        let url = `${_userUrls.deactiveUser}?limit=${pageLimit}&offset=${offset}&search=${encodeURIComponent(search)}&hospitalId=${hospitalId}&from=teraradiology`;
        let response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
            }
        })
        return await response.json()
    } catch (error) {
        return error;
    }
});

export default deactivateUserApi;
